"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = require("react");
const client_core_1 = require("@statsig/client-core");
const NoopEvaluationsClient_1 = require("./NoopEvaluationsClient");
const StatsigContext_1 = require("./StatsigContext");
function default_1(configName, options) {
  const {
    client,
    renderVersion
  } = (0, react_1.useContext)(StatsigContext_1.default);
  return (0, react_1.useMemo)(() => {
    if ((0, NoopEvaluationsClient_1.isNoopClient)(client)) {
      client_core_1.Log.warn("useDynamicConfig hook failed to find a valid StatsigClient for dynamic config '".concat(configName, "'."));
      return NoopEvaluationsClient_1.NoopEvaluationsClient.getDynamicConfig(configName, options);
    }
    return client.getDynamicConfig(configName, options);
  }, [configName, client, renderVersion, ...(options ? Object.values(options) : [])]);
}
exports.default = default_1;